var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"asset-es","category-name":"資産運用（不動産・その他）"}})}
var staticRenderFns = []

export { render, staticRenderFns }